var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vSelect',{attrs:{"placeholder":_vm.t(_vm.placeholder),"label":_vm.labelKey,"reduce":_vm.reduce,"value":_vm.value,"clearable":_vm.clearable,"multiple":_vm.multiple,"options":_vm.options},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }